// @ts-check

/**
 * Resolves the Edit Image submit button label.
 *
 * A pending upload or generated image replaces the stored file, so the label
 * says "Replace"; a changed lobby visibility appends the publish action.
 *
 * @param {Object} state
 * @param {boolean} state.hasPendingFile
 * @param {number} state.currentActive - 1 when the image will be published.
 * @param {number} state.initialActive - Visibility the modal opened with.
 * @returns {string}
 */
export function editSubmitLabel({ hasPendingFile, currentActive, initialActive }) {
  const verb = hasPendingFile ? 'Replace' : 'Save';
  if (currentActive === initialActive) return verb;
  return currentActive === 1 ? verb + ' & Publish' : verb + ' & Unpublish';
}

/**
 * Resolves the in-flight label shown while the Edit Image form submits.
 *
 * @param {boolean} hasPendingFile
 * @returns {string}
 */
export function editSubmitPendingLabel(hasPendingFile) {
  return hasPendingFile ? 'Replacing...' : 'Saving...';
}
